module.exports = __webpack_public_path__ + "img/mobile_app_banner_mobile_fr.862f1636.png";